module.exports = __webpack_public_path__ + "static/media/codeBallSounds.a7ec9bdf.gif";